
define('lib/require.text!../templates/message.html',[],function () { return '<h4 style="margin-top: 23px">From: <span data-bind="text: message.from"></span>, <span data-bind="text: message.year"></span> <span data-bind="newWindow: []"></h4>\r\n\r\n<span data-bind="html: message.text"></span>\r\n\r\n<p><a data-bind="attrLeagueUrl: {href: [\'inbox\']}">Return To Inbox</a></p>';});

